import Swiper, {Navigation} from 'swiper'
import { linkScroll } from '@/utils/dom'
import router from '@/router'
import store from '@/store/'

/**
 * ユーザー定義HTMLの初期化処理
 * @param {HTMLElement} rootElem HTMLが埋め込まれる親要素
 */
export default function initInjectedHTML(rootElem) {
  initLinks(rootElem.querySelectorAll('a'))
  initButtons(rootElem.querySelectorAll('.button'))
  initCarousel(rootElem.querySelectorAll('.swiper-container'))
}

/**
 * リンク初期化
 * @param {NodeListOf<HTMLElement>} links リンク要素
 */
function initLinks(links) {
  Array.prototype.forEach.call(links, link => {
    const href = link.getAttribute('href')
    if (isExternal(href)) {
      return false
    }
  
    // 画面内リンク
    if (!href || href.indexOf('#') === 0) {
      handleInPageLink(link)
      return false
    }
  
    // 案件ID埋め込み
    link.setAttribute('href', replaceBusinessId(href))
  
    // 内部リンクはVueRouter化する
    link.addEventListener('click', handleLinkInternal, false)
  })
}

/**
 * 外部リンク判定
 * @param {string} href URL文字列
 */
function isExternal(href) {
  // http(s)またはtelまたはmailtoを外部リンクとみなす
  return /^(https?:\/\/|tel:|mailto:).+$/.test(href)
}

/**
 * 内部リンク処理
 * @param {Event} event クリックイベント
 */
function handleLinkInternal(event) {
  event.preventDefault()
  const target = event.target
  router.push({ path: target.pathname })
}

/**
 * ページ内リンク処理
 * @param {HTMLElement} link リンク要素
 */
function handleInPageLink(link) {
  const href = link.getAttribute('href') || link.getAttribute('name')
  if (!href) {
    return false
  }

  const to = href.indexOf('#') === 0 ? href : `#${href}`

  link.addEventListener('click', e => {
    e.preventDefault()
    emulateLocationChange(to)
    linkScroll(to)
  })
}

/**
 * :target擬似クラスを模倣する
 * @param {string} to ページ内リンク
 */
function emulateLocationChange(to) {
  history.pushState(null, null, to)

  Array.prototype.forEach.call(
    document.querySelectorAll('.target'),
    target => target.classList.remove('target')
  )

  const elem = document.querySelector(to)
  if (elem) {
    elem.classList.add('target')
  }
}

/**
 * ボタン初期化
 * @param {NodeListOf<HTMLElement>} buttons ボタン要素
 */
function initButtons(buttons) {
  Array.prototype.forEach.call(buttons, button => {
    button.classList.add('waves-effect', 'waves-light')
  })
}

/**
 * カルーセル初期化
 * @param {NodeListOf<HTMLElement>} elems カルーセル親要素
 */
function initCarousel(elems) {
  Array.prototype.forEach.call(elems, elem => {
    new Swiper(elem, {
      modules: [Navigation],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    })
  })
}

/**
 * 案件ID埋め込み
 * @param {string} url
 * @returns {string}
 */
export function replaceBusinessId(url) {
  const businessId = store.getters['auth/businessId']
  return url.replace(/##businessId##/g, businessId)
}
